import React from "react";
import type { RequirementEligibility } from "@api/services/job-post/pure-requirements-evaluator";
import { JobPostAcceptMatchDialog } from "./job-post-accept-match-dialog";
import { JobPostExternalAcceptDialog } from "./job-post-external-accept-dialog";

export type AcceptableJob = {
  id: string;
  externalUrl?: string | null;
  eligibility?: RequirementEligibility;
};

/**
 * Routes the user to the right accept-flow based on whether the job is
 * external. Callers store the full job (or this subset) in state so the
 * dialog gets its server-evaluated eligibility directly — no per-render
 * lookup against the parent's job list and no follow-up request.
 */
export const JobAcceptDialog: React.FC<{
  job: AcceptableJob;
  onClose: () => void;
  onSuccess: () => Promise<void> | void;
  sourceUserId?: string | null;
  alreadyLiked?: boolean;
}> = ({ job, onClose, onSuccess, sourceUserId, alreadyLiked }) => {
  if (job.externalUrl) {
    return (
      <JobPostExternalAcceptDialog
        jobId={job.id}
        eligibility={job.eligibility}
        externalUrl={job.externalUrl}
        onClose={onClose}
        onSuccess={() => void onSuccess()}
        alreadyLiked={alreadyLiked}
      />
    );
  }
  return (
    <JobPostAcceptMatchDialog
      jobId={job.id}
      eligibility={job.eligibility}
      onClose={onClose}
      onSuccess={() => void onSuccess()}
      sourceUserId={sourceUserId}
    />
  );
};
